// Steps components
const FilmDetail = () => import('./steps/FilmDetail');
const CollaboratorDetails = () => import('./steps/CollaboratorDetails');
// const FilesMedia = () => import('./steps/FilesMedia');
const NewFilesMedia = () => import('./steps/NewFilesMedia');
const AdditionalDetail = () => import('./steps/AdditionalDetail');
const Terms = () => import('./steps/Terms');
const VideoUpload = () => import('./steps/VideoUpload');

export default [
  { label: '1. Upload',
    component: VideoUpload,
  }, {
    label: '2. Details',
    component: FilmDetail,
  }, {
    label: '3. Collaborators',
    component: CollaboratorDetails,
  }, {
    label: '4. Files',
    // component: FilesMedia,
    component: NewFilesMedia,
  }, {
    label: '5. Additional',
    component: AdditionalDetail,
  }, {
    label: '6. Terms',
    component: Terms,
  },
];



// WEBPACK FOOTER //
// ./src/components/Submission/children.js